<template>
  <div class="ewmapply">
    <headerBar title="二维码申请"></headerBar>
    <div class="box710">
       <div class="item">
          <div class="item_l">申请数量:</div> 
          <select name="type" id="sel" v-model="selected" @select="changeType()">
            <option v-for="(item,index) in appnumber" :key="index" :value ="item.money">{{item.num}}</option>
          </select>
       </div>
       <div class="item">
         <div class="item_l">收货人:</div> 
         <input type="text" placeholder="请输入收货人" v-model="name">
       </div>
       <div class="item">
         <div class="item_l">联系方式:</div> 
         <input type="text" v-model="mobile" placeholder="请输入联系方式">
       </div>
       <div class="item">
         <div class="item_l">所选地区：</div> 
         <van-cell id="clear" is-link @click="showPopup" v-model="showAddr">
          请选择区域<br/>
          <span class="showAddr">{{showAddr}}</span>
        </van-cell>
        <van-popup
          v-model="show"
          position="bottom"
          :style="{ height: '50%' ,padding:'16px'}"
        >
          <van-area
            :area-list="areaList"
            :columns-placeholder="['请选择', '请选择', '请选择']"
            value="110000"
            title="选择地址"
            @change="changeAddr"
            @cancel="cancelChoose"
            @confirm="chooseThis"
          />
        </van-popup>
       </div>
       <div class="item">
         <div class="item_l">详细地址:</div> 
         <input type="text" placeholder="请输入详细地址" v-model="address">
       </div>
       <div class="item">
         <div class="item_l">费用：</div> 
         <div class="money">{{selected}}元</div>
       </div>
       <div class="item">
         <div class="item_l">邮费：</div> 
         <div class="money"> {{postage}}元</div>
       </div>
    </div>
    <p class="notice">备注：申请成功后不能退款</p>
    <div class="kuang" @click="submit">
      <div class="bgmask"></div>
      <p>确认提交</p>
    </div>
  </div>
</template>
<script>
/*引入vant ui*/
import Vue from 'vue';
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

import areaList from '../../assets/area/area';
import { Toast } from 'mint-ui';
export default {
  data() {
    return {
      goods_id:0,
      num:'',
      selected: '',
      name:'',
      mobile:'',
      region:'',
      areaList,
      show: false,  //是否显示弹出层
      address: '',  //绑定详细地址输入框
      showAddr: '',      //显示地址
      appnumber:'',
      postage:0
    };
  },
  created() {
    this.goods_id = this.$route.query.goods_id || '';
    if(this.goods_id=='')this.$router.push('/');
  },
  mounted(){
    //判断是否登陆
    if (!window.localStorage.getItem('is_check_login') || window.localStorage.getItem('is_check_login') == 0) {
      this.$router.push('/login');
    }else{
      this.applicationsNumber()
    }
  },
  methods: {
    applicationsNumber(){
      this.$request.post('/front/signOrder/numAndPrice', {}, res => {
        console.log(res);
        if (res.status == 1) {
          this.appnumber = res.result;
          this.selected = res.result[0].money;
          this.num = res.result[0].num;
        }
      });
    },
    changeProduct(event) {
      this.ProductActive = event.target.value; //获取option对应的value值
      console.log("你选中了",this.ProductActive)
    },
    changeType(){
        this.num = sel.options[sel.selectedIndex].text;
    },
    submit(){
      if (!this.name) {
        Toast('收货人不能为空');
        return false;
      }
      if (!this.mobile) {
        Toast('联系方式不能为空');
        return false;
      }
      if (!this.region) {
        Toast('请选择地区');
        return false;
      }
      if (!this.address) {
        Toast('详细地址不能为空');
        return false;
      }
      let data = new FormData();
      data.append('goods_id', this.goods_id);
      data.append('num', this.num);
      data.append('name', this.name);
      data.append('mobile', this.mobile);
      data.append('region', this.region);
      data.append('address', this.address);
      this.$request.post('/front/signOrder/applyCode', data, res => {
        if (res.status == 1) {
          let order_id = res.result.order_id;
          console.log("order_id",res)
          this.$router.push('/cashier?order_id=' + order_id);
        } else {
          Toast(res.msg);
        }
      });
    },
    //控制popup组件的弹出和隐藏
      showPopup () {
        this.show = true
        // document.getElementById('clear').innerHTML = '';
        this.showAddr = ""
      },
      //改变地址选择，当切换省市区时进行数据留存
    changeAddr (picker) {
      //value=0改变省，1改变市，2改变区
      let val = picker.getValues()
      this.resAddr = val
    },
      //选好地址后点击确定
    chooseThis () {
      this.show = false
      //选中地址成功后回显
      if(this.resAddr[0].code == 9000){
        this.showAddr = ""
        
      }else{
        this.showAddr = this.resAddr[0].name + '-' + this.resAddr[1].name + '-' + this.resAddr[2].name;
        this.region = this.resAddr[0].code + '|' + this.resAddr[1].code + '|' + this.resAddr[2].code;
        let data = {
          region : this.region
        }
        // new FormData();
        // data.append('region', this.region);
        this.$request.post('/front/api/postageByRegion',data, res => {
          console.log(res)
          if (res.status == 1) {
            this.postage = res.result.postage
          } 
        })
      }
    },
    //取消选中城市
    cancelChoose(){
       this.show = false
       this.$refs.myArea.reset()// 重置城市列表
    }
  }
};
</script>

<style lang="scss" scoped>
  .van-cell{
    width: 4.6rem;
    border: 1px solid #cccccc;
    border-radius: 5px;
    padding: 0.12rem 3px 0.12rem 0.1rem;
  }
  .van-cell__value--alone{
    color: #757575;
    font-size: 0.3rem;
  }
  .showAddr{
    display:inline;
  }
  .money{
    width: 4.5rem;
  }
  .money{
    margin-left: 1rem;
  }
  .ewmapply{
    padding-top: 0.8rem;
    .item{
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin: 0.3rem 0;
      select{
        width: 4.6rem;
        height: 0.7rem;
        background: #fff;
        font-size: 0.3rem;
        border: 1px solid #ccc;
        border-radius: 5px;
        color: #757575;
      }
      input{
        display: block;
        width: 4.5rem;
        height: 0.7rem;
        line-height: 0.7rem;
        border: 1px solid #cccccc;
        border-radius: 5px;
        padding-left: 0.1rem;
        font-size: 0.3rem;
      }
      .down{
        position: absolute;
        right: 0.25rem;
        width: 0.15rem;
        height: 0.3rem;
        transform: rotate(90deg);
      }
    }
    .notice{
      padding: 0 0.2rem;
      color: #299E72;
    }
    .kuang{
      margin-top: 0.8rem;
      border-color:#299e72;
      .bgmask{
        background:#299e72;
      }
      p{
        color: #299E72;
        font-size: 0.38rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/ewmApply.vue